import React from 'react';
import { useState, useEffect } from "react";
import axios from "axios";
import Header from './components/Header';
import GroupLogo from './components/GroupLogo';
import Hero from './components/Hero';
import MusicFrontPage from './components/MusicFrontPage';
import Tour from './components/Tour';
import Tour_Past from './components/Tour_Past';
import Photos from './components/Photos';
import Video from './components/Video';
import Contact from './components/Contact';
import PlanScene from './components/PlanScene';
import Footer from './components/Footer';


import './index.css';
import { Helmet } from 'react-helmet';
import { Group } from 'lucide-react';



export default function App() {


    const band = {
        name: 'Palladium',
        tagline: '',
        bio: '',
        mail: '',
        logo: 'logo.png',
        photo: 'groupe.jpg',
        video: 'palladium_presentation.mp4',
        socials: [
            { name: 'Instagram', href: 'https://www.instagram.com/palladium_off?igsh=d2x1NGYydm12YzVy' },
            { name: 'Spotify', href: 'https://open.spotify.com/artist/0MyzAsy9H4dOBUr9k494G1?si=fw2ZNyK6Sm6VQa-x55wceQ' },
            { name: 'YouTube', href: 'https://youtube.com/@palladium6745?si=MHm_Ps0ttVq6ruOR' },
        ],
    }

    const logoGroupe = {
        src: 'logo_groupe.png',
    }

    const plan = {
        src: 'plan_scene.jpg',
    }

    const [musics, setMusics] = useState([]);
    useEffect(() => {
        axios.get("https://api.palladium.rocks/musics")
        .then(res => setMusics(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
        console.error(err);
        setMusics([]);
        });
    }, []);


    const [tour, setTour] = useState([]);
    useEffect(() => {
        axios.get("https://api.palladium.rocks/concerts_futurs")
        .then(res => setTour(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
        console.error(err);
        setTour([]);
        });
    }, []);

    const [tour_past, setTourPast] = useState([]);
    useEffect(() => {
        axios.get("https://api.palladium.rocks/concerts_passes")
        .then(res => setTourPast(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
        console.error(err);
        setTourPast([]);
        });
    }, []);

    
    
    
    const [videos, setVideos] = useState([]);
    useEffect(() => {
        axios.get("https://api.palladium.rocks/videos")
        .then(res => setVideos(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
        console.error(err);
        setVideos([]);
        });
    }, []);
    

    const [gallery, setGallery] = useState([]);
    useEffect(() => {
        axios.get("https://api.palladium.rocks/photos")
        .then(res => setGallery(Array.isArray(res.data) ? res.data : []))
        .catch(err => {
        console.error(err);
        setGallery([]);
        });
    }, []);


    return (
        <div className="min-h-screen bg-black text-white antialiased">
            <Helmet>
                <title>Palladium</title>
            </Helmet>
            <Header band={band} />
            <GroupLogo band={logoGroupe} />
            <Hero band={band} />
            <MusicFrontPage musics={musics} />
            <Tour tour={tour} />
            {/* Tour Passé 
            <Tour_Past tour={tour_past} />
            */}
            <Photos gallery={gallery} />
            {/* Videos Section
            <Video videos={videos} />
            */}
            <Contact band={band} />
            <PlanScene plan={plan} />
            <Footer band={band} />
        </div>
    );
}